import _Chat from './chat';
import _ChatItem from './chat-item';
import _ChatInput from './chat-input';
import _ChatContent from './chat-content';
import _ChatAI from './chat-ai';
import _ChatMofa from './chat-mofa';
import _ChatAction from './chat-action';
import withInstall from '../utils/withInstall';
import { TdChatProps, TdChatItemProps, TdChatListProps, TdChatContentProps } from './type';

import './style';

export * from './type';
export type ChatProps = TdChatProps;
export type ChatItemProps = TdChatItemProps;
export type ChatListProps = TdChatListProps;
export type ChatContentProps = TdChatContentProps;
export const Chat = withInstall(_Chat);
export const ChatItem = withInstall(_ChatItem);
export const ChatInput = withInstall(_ChatInput);
export const ChatContent = withInstall(_ChatContent);
export const ChatAI = withInstall(_ChatAI);
export const ChatMofa = withInstall(_ChatMofa);
export const ChatAction = withInstall(_ChatAction);
export default Chat;
